import { countriesDa } from './da';
import { countriesEn } from './en';
import { countriesFo } from './fo';
import { countriesNo } from './no';

export const languageToCountries: Record<string, Record<string, string>> = {
  da: countriesDa,
  en: countriesEn,
  fo: countriesFo,
  no: countriesNo,
} as const;
